import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import InlineSVG from 'svg-inline-react'
import { useSelector } from 'react-redux'
import * as Selectors from 'state/selectors'
import { getUsernameFromSessionProfile } from 'shared/utils/helper'

import iconOnline from 'assets/icons/ico-status-online.svg'
import iconOffline from 'assets/icons/ico-placeholder.svg'

// import iconCollapse from 'assets/icons/ico-collapse.svg'

const Container = styled.div`
  margin-right: 10px;
  margin-bottom: 20px;
`

const usernameActivePopoverStyling = props => props.isPopoverShown &&
  css`
  color: rgba(0, 0, 0, .7);
`

const Username = styled.div`
  margin-left: 2px;
  color: #90A1B0;
  transition: color .3s ease;
  
  ${usernameActivePopoverStyling}
`

const UserBlock = styled.div`
  display: flex;
  flex-direction: row;
  
  margin-top: 2px;
  margin-left: 2px;
`

const teamActivePopoverStyling = props => props.isPopoverShown &&
  css`
  color: rgba(0, 0, 0, 1);
`

const Team = styled.span`
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 4px;
  
  transition: color .3s ease;
  
  ${teamActivePopoverStyling}
`

const NavHeader = ({ isOnline, isPopoverShown }) => {
  const profile = useSelector(Selectors.getUserProfile)
  const organisation = useSelector(Selectors.getActiveOrganisation)

  return (
    <Container>
      <Team
        isPopoverShown={isPopoverShown}
      >
        { organisation?.name || 'No organisation' }
      </Team>

      <UserBlock>
        { isOnline ? <InlineSVG src={iconOnline} /> : <InlineSVG src={iconOffline} /> }
        <Username
          isPopoverShown={isPopoverShown}
        >
          { getUsernameFromSessionProfile(profile) }
        </Username>
      </UserBlock>
    </Container>
  )
}
NavHeader.defaultProps = {
  isOnline: true
}
NavHeader.propTypes = {
  isOnline: PropTypes.bool,
  isPopoverShown: PropTypes.bool
}

export default NavHeader
